/* eslint-disable import/prefer-default-export */
export const quotationQueryKeys = {
  quotationCustomLongfield01Details: (id: string) => ["custom-longfield01", "detail", id],
  costDetails: (id: string) => ["cost", "detail", id],
  quotationList: (id: string) => ["quotation-list", id],
  assignedTeamList: (id: string, config: any) => ["assigned-team-list", id, config],
};
